import type { CustomSettingConfig } from '@/_pages/system-users/shared/custom-settings/types';

import { companyFilterSettingsSchema, type CompanyFilterSettingsSchema } from './schema';

export const COMPANY_FILTERS_CONFIG: CustomSettingConfig<CompanyFilterSettingsSchema> = {
  name: 'company_filters',
  defaultValue: {
    revenueType: 'gross' as const,
    consolidatedByYear: false,
  },
  schema: companyFilterSettingsSchema,
};
